import type { ReactElement, SVGProps } from 'react'

/**
 * Location-fill (paper-plane) glyph for MyLocationButton (18 × 18).
 *
 * Path data byte-identical to
 * `metro/docs/superpowers/specs/assets/routecard-v2/icon-location-fill.svg`
 * (Figma export). Single filled path bound to `currentColor` so the
 * button tints it via the `text/secondary` token.
 */
export function IconLocationFill(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M16.125 1.875L2.1 8.475C2.02216 8.51674 1.95833 8.58046 1.91646 8.65823C1.87458 8.73599 1.85652 8.82436 1.86452 8.91232C1.87251 9.00028 1.90622 9.08394 1.96143 9.15287C2.01664 9.22181 2.09091 9.27298 2.175 9.3L7.8 10.2L9.45 15.825C9.47702 15.9091 9.52819 15.9834 9.59713 16.0386C9.66606 16.0938 9.74972 16.1275 9.83768 16.1355C9.92564 16.1435 10.014 16.1254 10.0918 16.0835C10.1695 16.0417 10.2333 15.9778 10.275 15.9L16.125 1.875Z"
        fill="currentColor"
      />
    </svg>
  )
}
